// extracted by mini-css-extract-plugin
export var home = "home-module--home--24INF";
export var text = "home-module--text--da7_l";
export var homeImg = "home-module--home-img--2lDen";
export var icons = "home-module--icons--3Ex1-";
export var btn = "home-module--btn--2Jhvd";